module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "halftitlepage",
      "id": "bkht"
    }
  }, [_c('h1', {
    staticClass: "bkht"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "i",
      "epub:type": "pagebreak",
      "id": "pi",
      "role": "doc-pagebreak"
    }
  }), _vm._v("The Next Supercontinent")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13942430","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-mitchell-0002.vue
// module id = 57
// module chunks = 0